export const vacancies = [
  // {
  //   id: "1",
  //   title: "1С-разработчик",
  //   description: "Разработка и поддержка решений на платформе 1С:Предприятие",
  //   requirements: "Опыт работы от 2 лет с 1С:Предприятие, знание конфигурирования и программирования на 1С",
  //   location: "Минск",
  //   salaryRange: "от 5 000 BYN",
  //   status: "published",
  //   type: "Полная занятость",
  //   experience: `
  //       <ul>
  //         <li>Опыт работы с 1С:Предприятие от 2+ лет</li>
  //         <li>Знание конфигурирования и программирования на 1С</li>
  //         <li>Опыт разработки и внедрения решений на 1С</li>
  //         <li>Знание SQL и основ баз данных</li>
  //         <li>Опыт работы с типовыми конфигурациями 1С</li>
  //         <li>Умение читать и модифицировать чужой код</li>
  //         <li>Базовые знания бухгалтерского учета</li>
  //       </ul>
  //     `,
  //   benefits: `
  //       <ul>
  //         <li>Гибкий график работы</li>
  //         <li>Возможность удаленной работы</li>
  //         <li>Конкурентная зарплата</li>
  //         <li>ДМС после испытательного срока</li>
  //         <li>Оплата профессионального обучения и курсов</li>
  //         <li>Современное оборудование</li>
  //         <li>Дружная команда профессионалов</li>
  //         <li>Интересные проекты для крупных клиентов</li>
  //       </ul>
  //     `,
  //   responsibilities: `
  //       <ul>
  //         <li>Разработка и доработка конфигураций 1С</li>
  //         <li>Написание и отладка программного кода на 1С</li>
  //         <li>Интеграция с внешними системами</li>
  //         <li>Оптимизация производительности решений</li>
  //         <li>Тестирование и отладка</li>
  //         <li>Документирование решений</li>
  //         <li>Консультация пользователей</li>
  //         <li>Участие в проектах внедрения</li>
  //       </ul>
  //     `,
  //   date: "21 марта 2025"
  // },
  
  // {
  //   id: "2",
  //   title: "Backend разработчик (PHP/Laravel)",
  //   description: "Разработка и оптимизация серверной части веб-приложений на Laravel",
  //   requirements: "Опыт работы от 2 лет с PHP 8+, Laravel, MySQL/PostgreSQL, Redis",
  //   location: "Минск",
  //   salaryRange: "от 5 000 BYN",
  //   status: "published",
  //   type: "Полная занятость",
  //   experience: `
  //       <ul>
  //         <li>Опыт коммерческой разработки на PHP от 2+ лет</li>
  //         <li>Уверенное знание PHP 8+ и Laravel</li>
  //         <li>Опыт работы с MySQL/PostgreSQL</li>
  //         <li>Знание Redis и других кэширующих систем</li>
  //         <li>Опыт работы с REST API</li>
  //         <li>Понимание принципов SOLID</li>
  //         <li>Опыт работы с Git</li>
  //         <li>Базовые знания Linux</li>
  //       </ul>
  //     `,
  //   benefits: `
  //       <ul>
  //         <li>Гибкий график работы</li>
  //         <li>Возможность удаленной работы</li>
  //         <li>Конкурентная зарплата</li>
  //         <li>ДМС после испытательного срока</li>
  //         <li>Оплата профессионального обучения и курсов</li>
  //         <li>Современное оборудование</li>
  //         <li>Дружная команда профессионалов</li>
  //         <li>Интересные проекты для крупных клиентов</li>
  //       </ul>
  //     `,
  //   responsibilities: `
  //       <ul>
  //         <li>Разработка серверной части веб-приложений</li>
  //         <li>Оптимизация производительности</li>
  //         <li>Проектирование и разработка API</li>
  //         <li>Работа с базами данных</li>
  //         <li>Написание unit-тестов</li>
  //         <li>Код-ревью</li>
  //         <li>Документирование кода</li>
  //         <li>Участие в планировании архитектуры</li>
  //       </ul>
  //     `,
  //   date: "22 марта 2025"
  // }
  // {
  //   id: "3",
  //   title: "QA-инженер",
  //   description: "Тестирование и обеспечение качества веб-приложений",
  //   requirements: "Опыт работы от 3 лет в тестировании web, mobile и desktop-приложений",
  //   location: "Минск",
  //   status: "published",
  //   type: "Полная занятость",
  //   experience: `
  //       <ul>
  //         <li>Коммерческий опыт: от 3 лет в тестировании web, mobile и desktop-приложений</li>
  //         <li>Знание основ тестирования: понимание роли тестирования в жизненном цикле ПО</li>
  //         <li>Анализ требований: умение анализировать и уточнять требования, выявлять потенциальные проблемы в продукте</li>
  //         <li>Опыт работы с Jira и Confluence: уверенное владение системой управления задачами</li>
  //         <li>Понимание работы браузера: навыки работы с DevTools для отладки</li>
  //         <li>Работа с логами: умение анализировать ошибки и находить причины проблем</li>
  //         <li>Опыт с брокерами сообщений: знание RabbitMQ</li>
  //         <li>Тестирование API: опыт работы с архитектурой REST API</li>
  //         <li>Инструменты тестирования: опыт работы с Postman, Swagger, Charles Proxy, SQL</li>
  //         <li>Написание тест-кейсов и чеклистов: опыт разработки и поддержания документации</li>
  //         <li>Коммуникативные навыки: отличные навыки взаимодействия с командой разработки и аналитиками</li>
  //         <li>Дисциплина и самоорганизация: высокий уровень дисциплины, адаптивность к изменениям</li>
  //         <li>Опыт работы с подключаемым оборудованием: понимание тестирования и интеграции</li>
  //       </ul>
  //     `,
  //   benefits: `
  //       <ul>
  //         <li>Гибкий график работы</li>
  //         <li>Возможность удаленной работы</li>
  //         <li>Конкурентная зарплата</li>
  //         <li>Оплата профессионального обучения и курсов</li>
  //         <li>Современное оборудование</li>
  //         <li>Дружная команда профессионалов</li>
  //         <li>Интересные проекты для крупных клиентов</li>
  //       </ul>
  //     `,
  //   responsibilities: `
  //       <ul>
  //         <li>Тестирование web, mobile и desktop-приложений</li>
  //         <li>Разработка и поддержка тест-кейсов и чеклистов</li>
  //         <li>Тестирование API и интеграций</li>
  //         <li>Работа с системами управления задачами</li>
  //         <li>Анализ и документирование багов</li>
  //         <li>Взаимодействие с командой разработки</li>
  //         <li>Участие в планировании и оценке задач</li>
  //         <li>Тестирование производительности и безопасности</li>
  //       </ul>
  //     `,
  //   date: "19 мая 2025"
  // }
];
